import log from "loglevel";
log.setLevel("production" !== "development" ? "silent" : "debug");
export const debug = log;
